import React from "react";
import { LOGO_URL, MOTTO_LINES, contactInfo, navLinks } from "../data/content";
export function Footer() {
  return <footer className="bg-ink text-paper" data-id="element-85" data-mp="3gg10g6ubc3z8">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-8" data-id="element-86" data-mp="3gh3s4gzgmag7">
        <div className="grid gap-14 lg:grid-cols-[1.5fr_1fr_1fr]" data-id="element-87" data-mp="32p5qssbzpiul">
          <div data-id="element-88" data-mp="36oy05797jt10">
            <div className="flex items-center gap-3" data-id="element-89" data-mp="36qheutf7tw0o">
              <img src={LOGO_URL} alt="" className="h-16 w-16 object-contain mix-blend-lighten" data-id="element-90" data-mp="3uf0phflqmkvx" />
              <span className="leading-tight" data-id="element-91" data-mp="38qw2zmvrtrp">
                <span className="block text-lg font-semibold tracking-wide" data-id="element-92" data-mp="37o2ul235f8m">FORTIS</span>
                <span className="block text-xs tracking-[0.18em] text-gold" data-id="element-93" data-mp="3lf5b71wvy9ro">SPORTS MANAGEMENT</span>
              </span>
            </div>
            <p className="mt-8 max-w-sm italic leading-relaxed text-paper/75" data-id="element-94" data-mp="3qblyjtw9gk3p">
              {MOTTO_LINES.map(line => <span key={line} className="block" data-id="element-95" data-mp="2ey9yzv7jannc">
                  {line}
                </span>)}
            </p>
          </div>

          <nav aria-label="Pie de página" data-id="element-96" data-mp="3labq1ri0byo9">
            <h2 className="text-sm font-semibold text-gold" data-id="element-97" data-mp="3lbdbmpwng3k8">Navegación</h2>
            <ul className="mt-5 space-y-3" data-id="element-98" data-mp="3gca859wbi5ed">
              {navLinks.map(link => <li key={link.href} data-id="element-99" data-mp="3v9b11gq8w6ef">
                  <a href={link.href} className="text-paper/75 transition-colors duration-150 ease-out hover:text-gold" data-id="element-100" data-mp="3v5dhwv3o3euj">
                    {link.label}
                  </a>
                </li>)}
              <li data-id="element-101" data-mp="34741locg5y7">
                <a href={contactInfo.transfermarktUrl} target="_blank" rel="noopener noreferrer" className="text-paper/75 transition-colors duration-150 ease-out hover:text-gold" data-id="element-102" data-mp="34pafb4q00ju">
                  Jugadores en Transfermarkt
                </a>
              </li>
            </ul>
          </nav>

          <div data-id="element-103" data-mp="ms6dmt769721">
            <h2 className="text-sm font-semibold text-gold" data-id="element-104" data-mp="mspppta55185">Contacto</h2>
            <ul className="mt-5 space-y-3 text-paper/75" data-id="element-105" data-mp="tvczjrxji5f5">
              <li data-id="element-106" data-mp="twxuhinrnqdj">
                <a href={contactInfo.whatsappUrl} target="_blank" rel="noopener noreferrer" className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-107" data-mp="tt9z0dyrgtw6">
                  WhatsApp: {contactInfo.whatsappDisplay}
                </a>
              </li>
              <li data-id="element-108" data-mp="1cmdzai6hi4zr">
                <a href={`mailto:${contactInfo.email}`} className="transition-colors duration-150 ease-out hover:text-gold" data-id="element-109" data-mp="1ckt3yqccii0u">
                  {contactInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 border-t border-ink-line pt-8 text-sm text-paper/55" data-id="element-110" data-mp="1riv4ero2yndv">
          © {new Date().getFullYear()} Fortis Sports Management. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}